export default __webpack_public_path__ + "static/unternehmen_1989-868deaa365902707040c239f15bff893.svg";